export default {
      id: "social-youtube-usage",
      viewBox: "0 0 22 15",
      url: __webpack_public_path__ + "img/icons.svg#social-youtube",
      toString: function () {
        return this.url;
      }
    }